import React from 'react';
import UserFocusItem from './UserFocusItem';
import './UserFocus.css';

const UserFocus = ({uName}) => {
  return (
    <div className='userFocus'>
      <div>
        <UserFocusItem title={uName} />        
      </div>
    </div>
  )
}

export default React.memo(UserFocus);